import { NotificationModule } from "@/store/modules/notification.store";
import { CustomerAccountMeModule } from "@/store/modules/customer-account-me.store";
import { NotificationFactory } from "./NotificationFactory";
import { UserModule } from "@/store/modules/me-user.store";
import Vue from "vue";

export class ReportNotificationHandler {
  static async check() {
    NotificationModule.clear();

    if (UserModule.isAuthenticated) {
      try {
        await CustomerAccountMeModule.getOne();
      } catch (e) {
        Vue.$log.error(e);
      }

      if (!CustomerAccountMeModule.currentAccount || Object.keys(CustomerAccountMeModule.currentAccount).length === 0) {
        NotificationFactory.createCustomerAccountMissingNotification();
      }
    }
  }
}
